module.exports = __webpack_public_path__ + "img/mapType.29541528.png";